module.exports = __webpack_public_path__ + "static/media/gym1.81cf0310.jpg";